'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _BaseContentCard = require('./BaseContentCard');

var _BaseContentCard2 = _interopRequireDefault(_BaseContentCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BaseContentCard2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseContentCard/index.js
// module id = 256
// module chunks = 11